import { huddleTransport } from "@/src/config/huddleTransport.js";

export default {
  async startHuddle(groupId, memberIds) {
    try {
      const payload = { group_id: Number(groupId) };
      if (memberIds && memberIds.length > 0) {
        payload.member_ids = memberIds.map(Number);
      }
      const res = await huddleTransport.post("/v1/huddles", payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while starting huddle: ", error);
      throw error;
    }
  },

  async getActiveHuddle(groupId) {
    try {
      const res = await huddleTransport.get(`/v1/huddles/groups/${groupId}`);
      return res.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        return { huddle: null };
      }
      console.error("An error occurred while fetching active huddle: ", error);
      throw error;
    }
  },

  async joinHuddle(sessionId) {
    try {
      const res = await huddleTransport.post(`/v1/huddles/${sessionId}/join`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while joining huddle: ", error);
      throw error;
    }
  },

  async leaveHuddle(sessionId) {
    try {
      const res = await huddleTransport.post(`/v1/huddles/${sessionId}/leave`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while leaving huddle: ", error);
      throw error;
    }
  },

  async endHuddle(sessionId) {
    try {
      const res = await huddleTransport.post(`/v1/huddles/${sessionId}/end`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while ending huddle: ", error);
      throw error;
    }
  },

  async inviteToHuddle(sessionId, userIds) {
    try {
      const res = await huddleTransport.post(`/v1/huddles/${sessionId}/invite`, { user_ids: userIds.map(Number) });
      return res.data;
    } catch (error) {
      console.error("An error occurred while inviting to huddle: ", error);
      throw error;
    }
  },

  async toggleMute(sessionId, muted) {
    try {
      const res = await huddleTransport.post(`/v1/huddles/${sessionId}/mute`, { muted });
      return res.data;
    } catch (error) {
      console.error("An error occurred while toggling mute: ", error);
      throw error;
    }
  },

  async fetchParticipants(sessionId) {
    try {
      const res = await huddleTransport.get(`/v1/huddles/${sessionId}/participants`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching participants: ", error);
      throw error;
    }
  },
};
